class Category {
    constructor(id, name, isRapidSearchType) {
        this.id = id;
        this.name = name;
        this.isRapidSearchType = isRapidSearchType;
    }
}

export default Category;